import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { DietaryTagsImagesEffects } from './dietary-tags-images.effects';
import { dietaryTagsImagesReducer } from './dietary-tags-images.reducer';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature('dietaryTagsImages', dietaryTagsImagesReducer), EffectsModule.forFeature([DietaryTagsImagesEffects])],
    exports: [],
    providers: [],
})
export class DietaryTagsImagesStateModule {}
